import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import './Projects.css';

export default function Projects(props) {
    const { projectData, setProjectData } = props;

    useEffect(() => {
        const query = `{
            projectCollection {
                items {
                    sys { id }
                    title
                    year
                    location
                    imagesCollection {
                        items {
                            url
                        }
                    }
                }
            }
        }`;

        window.fetch(`https://graphql.contentful.com/content/v1/spaces/1rl1jlxxxe6l/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer 45CfDXmLKyusG7xKSwYwBDNTqyV0EcQdgWKMi6MxNPQ",
            },
            body: JSON.stringify({ query }),
        })
        .then((response) => response.json())
        .then(({ data, errors }) => {
            if (errors) { console.error(errors); return; }
            let sorted = data.projectCollection.items.sort((a, b) => b.year - a.year);
            setProjectData(sorted);
        });
    }, []);

    if (!projectData) return <div>Loading...</div>;

    return (
        <div className="works-page">
            <div className="works-grid">
                {projectData.map((project) => {
                    const imageUrl = project.imagesCollection.items[0]?.url;
                    return (
                        <Link
                            to={`/project/${project.sys.id}`}
                            key={project.sys.id}
                            className="work-item"
                        >
                            <div className="work-image">
                                {imageUrl && <img src={imageUrl} alt={project.title} />}
                            </div>
                            <div className="work-info">
                                <span className="work-title">
                                    <em>{project.title}</em>, <span className="work-year">{project.year}</span>
                                </span>
                                <span className="work-meta">{project.location}</span>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}